﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconBarcode } from "@tabler/icons-react";

export const TiposCodigoBarraIcon = IconBarcode;
export const TiposCodigoBarraHelpText = "* Tipos de códigos de barra";

export class catTiposCodigoBarra extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposCodigoBarra";
        this.def.columns.c_category_id.defaultValue = "TiposCodigoBarra";
        this.Title = "Tipos de Códigos de barra";
        this.HelpText = TiposCodigoBarraHelpText;
        this.Icon = TiposCodigoBarraIcon;
    }
}